/** 仅构建目的地检索索引（当前语言） */
export function buildSearchIndex(i18n) {
  const m = i18n.messages[i18n.locale] || {};
  const list = [];
  const destinations = m.destinationDetail?.list || [];

  const cardList = m.home?.enjoy?.destinations || [];

  destinations.forEach((dest, index) => {
    if (!dest.heroTitle && !dest.tourTitle) return;
    const card = cardList[index] || {};
    list.push({
      type: "destination",
      title: dest.heroTitle,
      text: [
        card.tourName,
        dest.heroTitle,
        dest.tourTitle,
        dest.tourRoute,
        dest.tourDesc,
        (dest.highlights || []).join(" "),
        (dest.days || []).map((d) => `${d.title} ${(d.paragraphs || []).join(" ")}`).join(" "),
        dest.tourCode,
        dest.tourDays,
        dest.tourCities,
        dest.tourAccommodation,
      ]
        .filter(Boolean)
        .join(" "),
      path: `/destination/${index}`,
    });
  });

  return list;
}

export function searchSite(query, i18n) {
  const q = String(query || "")
    .trim()
    .toLowerCase();
  if (!q) return [];

  const index = buildSearchIndex(i18n);
  return index.filter((item) => {
    const haystack = `${item.title || ""} ${item.text || ""}`.toLowerCase();
    return haystack.includes(q);
  });
}
